import styled from 'styled-components';

const SpecialLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
`;
export default SpecialLabel;
